import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import getTimeDifference from "../../../../../../Common/TimeDifference";
import { formatNumberWithCommas, getPosttype } from "../../../../../../Common/AllDateTimeReleventFormate";
import DownloadwithDisplayProper from "../../../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import CustomReactQuillDescription from "../../../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import GetPrice from "../../PostedProjects/MineActiveProject/ProjectModels/GetPrice";
import GetLocation from "../../../../../../CustomComponents/GetLocation";
import CustomeCategoryandSubcategory from "../../../../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import DeadlineComponents from "../../../../../../Common/DeadlineComponents";
import ConfirmModal from "../../../../../../Common/ConfirmModal";
import { useSelector } from "react-redux";
import { decodeHtml } from "../../../../../../../assests/extention/commonfunction";

export default function MineJobDetails({ proposalcount, posts, cancelpost }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [confirmModal, setConfirmModal] = useState(false);
  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  const navigate = useNavigate();

  return (
    <div className="  project-details ">
      <div className="post-details">
        <div className="post-flex flex-wrap" style={{ rowGap: '10px' }}>
          <div>
            <h5>
              {decodeHtml(posts.title)} <span className="job">{getPosttype(posts.type)}</span>
            </h5>
            <div className="dollar-sec">
              <p>
                {/* <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                  alt=""
                /> */}
                <GetPrice
                  type={posts?.type}
                  price={posts?.price}
                  price2={posts?.price2}
                  hiring_type={posts?.hiring_type}
                />
              </p>
              {posts?.type == 3 ? (
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                    alt=""
                  />
                  Job type:
                  {posts?.work_location == 1
                    ? "Virtual"
                    : posts?.work_location == 2
                      ? "Physical"
                      : ""}
                </p>
              ) : (
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                    alt=""
                  />
                  <DeadlineComponents posts={posts} />
                </p>
              )}
              <p>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                  alt=""
                />
                Posted:{getTimeDifference(posts?.created_on)}
              </p>
            </div>
          </div>
          {(posts?.is_mine == 1 && proposalcount == 0 && posts?.status != 24) && (
            <div className="d-flex align-items-center edit-cancel-sec" style={{ columnGap: '20px' }}>
              <button
                onClick={() => navigate(`/${lan}/account/updatejob/${posts?.id}`)}
              >
                Edit details
              </button>
              <button
                onClick={() =>
                  setConfirmModal(true)
                }
              >
                Cancel
              </button>
            </div>
          )}
          {
            posts?.status == 24 &&
            <button   >
              It's Canceled
            </button>
          }
        </div>
        <GetLocation
          type={posts?.type}
          city_name={posts?.city_name}
          country_title={posts?.country_title}
        />
        <CustomeCategoryandSubcategory posts={posts} />
        <div className="lang-sec">
          <h6>Preferred language</h6>
          <p>{posts?.language_title}</p>
        </div>
        <div className="lang-sec">
          <h6>Description</h6>
          <CustomReactQuillDescription value={posts?.description} />
        </div>
        <div className="lang-sec">
          <h6>Competencies and expertise</h6>
          <div className="skills-expert">
            <div className="photoshop">
              {Array.isArray(posts?.skills) &&
                posts?.skills.map((item1, index1) => (
                  <p key={index1}>{decodeHtml(item1.title)}</p>
                ))}
            </div>
          </div>
        </div>
        {Array.isArray(posts?.files) &&
          posts?.files &&
          posts?.files?.length > 0 && (
            <div className="lang-sec">
              <h6>Attachments</h6>
              <div className="images">
                {posts?.files &&
                  Array.isArray(posts?.files) &&
                  posts?.files.map((item, index) => {
                    return <DownloadwithDisplayProper item={item} />;
                  })}
              </div>
            </div>
          )}
        <div className="lang-sec">
          <h6 className="activity-post"> Activity on this post</h6>
          <div className="post-p">
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                alt=""
              />
              Proposal: {posts?.proposal_count}
            </p>
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/eye.svg`}
                alt=""
              />
              Last viewed by client:
              {getTimeDifference(posts?.last_viewed_client)}
            </p>
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/interview.svg`}
                alt=""
              />
              Seen: {posts?.view_count}
            </p>
          </div>
        </div>
      </div>

      <ConfirmModal
        isOpen={confirmModal}
        toggle={() => setConfirmModal(false)}
        title="Confirm Cancellation"
        message={`Are you sure you want to cancel this post?`}
        confirmpopupmessage={`All pending logged time will be rejected, and payment will be released only for accepted logged time.This action cannot be undone.
          As per admin configuration, each user is allowed a limited number of cancellations. You have used ${profile?.settings?.total_cancelation || 0} out of ${profile?.settings?.max_cancelation || 0} allowed cancellations.`}
        onConfirm={() => cancelpost()}
        showConfirmModel={false}
      />
    </div>
  );
}
